import { PreAuthorization } from '@gozoki/api-types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { fetchPreAuthorizations } from '../queries/preAuthorizations.queries';

export const usePreAuthorizations = (storeId: number): UseQueryResult<PreAuthorization[], unknown> => {
    return useQuery({
        queryKey: ['pre-authorizations', storeId],
        queryFn: () => fetchPreAuthorizations(storeId),
    });
};
